import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import numeral from "numeral";

const style = {
  boxLabel: {
    display: "inline-block",
    marginTop: 16,
    marginLeft: 59
  },
  label: {
    height: 28,
    width: 118,
    color: "#0E283D",
    fontFamily: "Fira Sans",
    fontSize: 16,
    fontWeight: 600
  },
  trDevice: {
    display: "flex"
  },
  textPrice: {
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 20,
    fontWeight: 600,
    textAlign: "right",
    marginLeft: 169,
    width: 110
  },
  labelPrice: {
    color: "#A7A8A8",
    fontFamily: "Fira Sans",
    fontSize: 14,
    fontWeight: 400,
    display: "block"
  },
  boxEstimate: {
    borderTop: "1px solid #F2F2F2"
  }
};

const EstimatePrice = ({ classes, monthly }) => {
  const monthlyValue = numeral(monthly).format("$0,0.00");
  return (
    <div className={classes.boxEstimate}>
      <table className={classes.boxLabel}>
        <tbody>
          <tr className={classes.trDevice}>
            <td className={classes.label}>Billing estimate</td>
            <td className={classes.textPrice}>
              {monthlyValue}
              <span className={classes.labelPrice}>monthly</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

EstimatePrice.propTypes = {
  classes: PropTypes.object.isRequired,
  monthly: PropTypes.number.isRequired
};

export default injectSheet(style)(EstimatePrice);
